var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme + '-theme',attrs:{"id":"app"}},[_c('Menu',{attrs:{"theme":_vm.theme,"selected_tab":_vm.current_tab_selection},on:{"tab_selected":_vm.onTabSelected,"toggle-theme":_vm.toggleTheme}}),_c('Content',{attrs:{"selected_tab":_vm.current_tab_selection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }